const styles = {
  container: {},

  sectionTitle: {
    marginBottom: 2
  },

  skeletonCard: {
    marginBottom: 3,
    borderRadius: 2
  },

  skeletonContent: {
    padding: 2
  },

  sideSection: {
    marginBottom: 3
  },

  contentContainer: {
    marginTop: 2
  },

  headerActionsContainer: {
    display: 'flex'
  },

  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: 1
  }
}

export default styles
